import { PostModel } from "common/models/baseModel";

import { useQuery } from "@tanstack/react-query";
import { ISpecializationGridFilter } from "./types";
import { specialization } from "./query";

export function useListQuery(model: PostModel<ISpecializationGridFilter>) {
  return useQuery(specialization.list(model));
}

export function useGetQuery(id: number) {
  return useQuery({
    ...specialization.get(id),
    enabled: id > 0,
  });
}

export function useViewQuery(id: number, isOpen: boolean) {
  return useQuery({
    ...specialization.view(id),
    enabled: id > 0 && isOpen,
  });
}

export function useGetAllSpecializationValuesQuery() {
  return useQuery(specialization.getAllspecializationValues);
}

export function useSpecializationValuesQuery() {
  return useQuery(specialization.specializationValues);
}
